

import {defineComponent, onMounted, onUnmounted, Teleport} from 'vue';

export default defineComponent({
  name: 'Modal',
  inheritAttrs: false,
  components: {},
  setup(props, context) {

    onMounted(() => {
      document.body.classList.add("modal-open")
    })
    onUnmounted(() => {
      document.body.classList.remove("modal-open")
    })

    return () =>
      <Teleport to="body #app .app">
        <div class="modal" {...context.attrs}>
          {context.slots.default?.()}
        </div>
      </Teleport>
  }
});
